import React, { useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { CloudUpload, InsertDriveFile, Close } from "@mui/icons-material";

const FileUploadField = ({
  label,
  required,
  value,
  onChange,
  error,
  accept = "image/*,application/pdf",
}) => {
  const inputRef = useRef(null);

  const isFile = value instanceof File;
  const isUrl = typeof value === "string" && value.trim() !== "";

  const fileName = isFile
    ? value.name
    : isUrl
      ? decodeURIComponent(
          value.split("/").pop()?.split("?")[0] || "Uploaded document",
        )
      : "";

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      onChange(file);
    }

    e.target.value = "";
  };

  const handleRemove = () => {
    onChange(null);
  };

  const handleView = () => {
    if (isUrl) {
      window.open(value, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: 12.5,
          fontWeight: 650,
          color: "#3A4441",
          mb: 0.75,
        }}
      >
        {label}
        {required && (
          <Box component="span" sx={{ color: "#B3261E" }}>
            {" "}
            *
          </Box>
        )}
      </Typography>

      <input
        ref={inputRef}
        type="file"
        accept={accept}
        hidden
        onChange={handleFileSelect}
      />

      {value ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            border: "1px solid #E6ECEA",
            borderRadius: 2,
            p: 1.25,
            backgroundColor: "#FAFBFA",
          }}
        >
          <InsertDriveFile
            sx={{
              color: "#0E7A6E",
              fontSize: 20,
            }}
          />

          <Typography
            onClick={handleView}
            sx={{
              fontSize: 13,
              flex: 1,
              color: "#12181A",
              cursor: isUrl ? "pointer" : "default",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              "&:hover": isUrl
                ? {
                    textDecoration: "underline",
                  }
                : {},
            }}
          >
            {fileName}
          </Typography>

          <IconButton size="small" onClick={handleRemove}>
            <Close sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      ) : (
        <Box
          onClick={() => inputRef.current?.click()}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            border: `1px dashed ${error ? "#B3261E" : "#E6ECEA"}`,
            borderRadius: 2,
            p: 1.25,
            cursor: "pointer",
            color: "#66766F",
            "&:hover": {
              borderColor: "#0E7A6E",
              backgroundColor: "#E6F5F2",
              color: "#0B5F56",
            },
          }}
        >
          <CloudUpload sx={{ fontSize: 20 }} />
          <Typography sx={{ fontSize: 13 }}>Click to upload</Typography>
        </Box>
      )}

      {error && (
        <Typography
          sx={{
            fontSize: 11.5,
            color: "#B3261E",
            mt: 0.5,
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default FileUploadField;
